import { Delete, Edit, PlayCircle } from "@mui/icons-material";
import { Backdrop, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { AddFlex, CustomText } from "../Components/reusableStyles";
import styled from "styled-components";

export const YoutubeEmbeddIframe = styled.iframe`
  width: 580px;
  height: 313px;
  max-width: 600px;
  max-height: 400px;
  border-radius: 12px;
  @media screen and (max-width: 1000px) {
    width: 90vw;
    height: 30vh;
    /* border-radius: 24px; */
  }
`;

const VideoCard = ({ video, updateVideo, deleteVideo, loading }) => {
  const [openYoutubeVideo, setOpenYoutubeVideo] = useState(false);
  function extractYouTubeVideoID() {
    const regex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = video.url.match(regex);
    return match ? match[1] : null;
  }

  function getYoutubeEmbedPreview(url) {
    const videoID = extractYouTubeVideoID(url);
    if (videoID) {
      const imgUrl = `https://img.youtube.com/vi/${videoID}/maxresdefault.jpg`;
      return imgUrl;
    } else {
      console.log("Invalid YouTube URL");
      return null;
    }
  }
  return (
    <>
      <AddFlex
        gap="10px"
        padding="0 20px 20px 20px"
        style={{ borderBottom: "1px solid #ececec" }}
      >
        <div
          style={{
            width: "35%",
            borderRadius: "12px",
            flexShrink: 0,
            position: "relative",
          }}
          onClick={() => {
            setOpenYoutubeVideo(true);
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "12px",
              objectFit: "cover",
            }}
            src={getYoutubeEmbedPreview(video.url)}
          />
          <AddFlex
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: "#00000040",
              left: 0,
              top: 0,
              borderRadius: "12px",
            }}
            alignItems="center"
            justify="center"
          >
            <PlayCircle sx={{ color: "white", fontSize: "40px" }} />
          </AddFlex>
        </div>
        <AddFlex gap="6px" flexDirection="column">
          <AddFlex alignItems="center" gap="10px">
            <CustomText color="#031E3B" fontWeight="500">
              {video.name}
            </CustomText>
            {loading === "edit" ? (
              <CircularProgress sx={{ fontSize: "14px" }} />
            ) : (
              <Edit
                sx={{ fontSize: "14px", cursor: "pointer" }}
                onClick={() => {
                  updateVideo();
                }}
              />
            )}
            {loading === "delete" ? (
              <CircularProgress size={14} />
            ) : (
              <Delete
                sx={{ fontSize: "14px", cursor: "pointer" }}
                onClick={() => {
                  deleteVideo();
                }}
              />
            )}
          </AddFlex>
          <CustomText
            fontSize="14px"
            color="#6B6B6B"
            fontWeight="300"
            lineClamp={4}
          >
            {video.description}
          </CustomText>
        </AddFlex>
      </AddFlex>
      <Backdrop
        open={openYoutubeVideo}
        sx={{ zIndex: "1111" }}
        onClick={() => setOpenYoutubeVideo(false)}
      >
        {openYoutubeVideo && (
          <YoutubeEmbeddIframe
            src={`https://www.youtube.com/embed/${extractYouTubeVideoID()}`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{
              position: "fixed",
              left: "0px",
              top: "0px",
              bottom: "0px",
              right: "0px",
              width: "90vw",
              height: "50vh",
              margin: "auto",
            }}
          />
        )}
      </Backdrop>
    </>
  );
};

export default VideoCard;
